/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Layout from "../../../../Layouts/Layout";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import Container from "../../../../../components/Container/Container";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import LpAdvocardMeta from "./LpAdvocardMeta";
import HowItWorksSectionContract from "../../../../../components/Sections/Contract/HowItWorksSection/HowItWorksSectionContract";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { contractTeaserCards } from "@/src/services/landingPageService";
import SpecialEnergyContractCheckin from "../../../../../components/Checkin/ContractCheckin/SpecialEnergyContractCheckin";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";

const LpSpecialEnergyCasesAdvocard = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpAdvocardMeta
        title={"Professionelle Hilfe im Vertragsrecht | Legalbird"}
        description={"Professionelle Hilfe im Vertragsrecht - Schnell, einfach und sicher! Jetzt beraten lassen!"}
      />
      <LandingPageTeaser
        teaserButtonText={"Jetzt starten"}
        headline={"Advocard Energie-Hilfe: Probleme mit Ihrem Anbieter?"}
        subheadline={"Wir sorgen dafür, dass Sie zu Ihrem Recht gelangen!"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={contractTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={PARTNER_IRIS.ADVOCARD} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <SpecialEnergyContractCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
      <HowItWorksSectionContract />
      <AttorneySection subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"} />
      <CustomerFeedback />
      {!isLoggedIn && (
        <Container>
          <SpecialEnergyContractCheckin idPrefix={"bottom"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
    </Layout>
  );
};

export default LpSpecialEnergyCasesAdvocard;
